// extracted by mini-css-extract-plugin
export default {"contentTabLink":"styles_contentTabLink__+cLeg","text-shadow":"styles_text-shadow__pR1xK","border-bottom":"styles_border-bottom__1E5T6","active":"styles_active__UqdAI"};